import { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import AuthContext from "../servicos/autorizacao/AuthContex";
import servicosColaborador from "../servicos/servicos-colaborador";
import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import { cpfMask } from "./components/cpfMask";
import bg from '../img/svgs/login/bglogin.svg'
import prancheta from '../img/svgs/login/prancheta1.svg'
import logo from '../img/svgs/logo-lev-milhas.svg';

const Login = () => {
  const { login } = useContext(AuthContext);
  const [esqueceu, setEsqueceu] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [email, setEmail] = useState("");
  const [auxEmail, setAuxEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpf, setCpf] = useState("");

  useEffect(() => {
    let aux = document.querySelector('#formUserName');
    aux.value = String(auxEmail).trim();
    setEmail(auxEmail);
  }, [auxEmail])

  const loginSubmit = async () => {
    let payload = {
      email: email,
      password: password
    }
    try {
      await login(payload);
    } catch (error) {
      console.log(error);
      toast.error('Não foi possível efetuar o login, por favor verifique suas credencias e tente novamente!')
    }
  };

  const recuperarSenha = () => {
    setEmail(auxEmail);
    setEsqueceu(true)
  }

  
 
  
  const handleEmail = (e) => {
    const email = e?.target?.value;
    setEmail(email)
  }
  const handlePassword = (e) => {
    const password = e?.target?.value;
    setPassword(password)
  }
  const handleCpf = (e) => {
    const cpf = e?.target?.value;
    setCpf(cpfMask(cpf));
  }

  const lembrouSenha = () => {
    setEsqueceu(false)
  }

  const obterNovaSenha = () => {
    const emailColaborador = {
      cpf: cpf
    }
    servicosColaborador.redefinirSenha(emailColaborador).then(response => {
      if (response?.status === 200) {
        setEsqueceu(false);
        toast(`${response.data.message}`, {
          autoClose: 15000,
        });
        let auxEmail = String(response.data.message).substring(41);
        setAuxEmail(auxEmail);

      } else {
        toast.error('Não foi possível enviar uma nova senha par o e-mail informado. Por favor verifique o e-mail e tente novamente!');
        
      }
    }).catch(error => {
      console.log(error);
      toast.error('Não foi possível enviar uma nova senha par o e-mail informado. Por favor verifique o e-mail e tente novamente!');

    })
    return <>
    </>
  }


  return (
    <>
      <ToastContainer />
      {!esqueceu && <div className="bg-login d-flex align-items-center" style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover', overflow: 'hidden' }}>
        <div className="square-login d-flex justify-content-between row align-items-center" >
          <img id="logo_lev_milhas" src={logo} alt="logo do lev milhas" />
          <div className="first">
          </div>
          <div className="second">
            <form className="d-flex  justify-content-center align-items-center row" onSubmit={handleSubmit(loginSubmit)}>
              <Form.Group className="d-flex justify-content-center mb-3" controlId="formUserName">
                <Form.Control
                  className="text-center mt-4 auxemail"
                  type="email"
                  placeholder="E-mail"
                  value={email}
                  {...register("email", { required: false })}
                  onChange={handleEmail} />
              </Form.Group>
              {errors.email && <p className="errosValidacao">Requerido</p>}
              {!esqueceu &&
                <Form.Group className="d-flex justify-content-center mb-3" controlId="formPassword">
                  <Form.Control
                    onSubmit={loginSubmit}
                    className="text-center"
                    type="password"
                    placeholder="Senha"
                    defaultValue={password}
                    {...register("password", { required: false })}
                    onChange={handlePassword}
                  />
                </Form.Group>}
              {errors.password && <p className="errosValidacao">Requerido</p>}

              <button className="w-25 mb-5 btn-login" variant="primary" type="submit" >
                Login
              </button>
            </form>
            <span className="d-flex justify-content-center mb-2 ">
              <button type="button" className="btn-esqueceu-senha" onClick={recuperarSenha}>Esqueceu suas credenciais?</button>
            </span>
          </div>
        </div>
        <div className="prancheta" style={{ backgroundImage: `url(${prancheta})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', }}>

        </div>

      </div>}
      {esqueceu && <div className="bg-login d-flex align-items-center" style={{ backgroundImage: `url(${bg})`, backgroundSize: 'cover' }}>
        <div className="square-login d-flex justify-content-between row align-items-center" >
          <div className="first">
          </div>
          <div className="second pt-5 pb-5">
            <form className="d-flex  justify-content-center align-items-center row" onSubmit={handleSubmit(obterNovaSenha)}>
              <Form.Group className="mb-3 ms-3 d-flex justify-content-center" controlId="formUserCpf">
                <Form.Control
                  className="input-cadastro"
                  type="number"
                  defaultValue={cpf}
                  placeholder="CPF (apenas número)"
                  {...register("cpf", { required: true, minLength: 11, maxLength: 11 })}
                  onChange={handleCpf}
                />
              </Form.Group>
              {errors.cpf && <p className="errosValidacao">Requerido</p>}

              <button className="w-50 me-2 mb-5 btn-login" type="submit">
                Obter nova senha
              </button>
              <button className="w-25 mb-5 btn-login" onClick={lembrouSenha} type="button">
                Voltar
              </button>
            </form>
          </div>
        </div>
        <div className="prancheta" style={{ backgroundImage: `url(${prancheta})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', }}>
        </div>
      </div>
      }

    </>
  );
};
export default Login;